
import ParcelThumbnail from "@/components/Parcel/ParcelThumbnail.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { gettersInstance } from "@/lib/util";
import { Watch } from "vue-property-decorator";

const StoreGetters = gettersInstance(["recentParcels", "selectedDate", "rasterKind", "selectedParcelId"]);

@Component({
  name: "RecentParcels",
  components: { ParcelThumbnail },
})
export default class RecentParcels extends mixins(MixedVue, StoreGetters) {
  static components: {
    ParcelThumbnail: typeof ParcelThumbnail;
  };

  get parcelsToList() {
    // Exclude the parcel we are currently viewing from the list and only show
    // the most recent 3 parcels.
    return this.recentParcels.filter((parcel) => parcel.id !== this.selectedParcelId).slice(-3);
  }

  @Watch("parcelsToList")
  parcelsToListChanged() {
    this.initTooltips();
  }

  mounted() {
    this.initTooltips();
  }
}
